import request from '@/utils/request'

export function getAuthUrl() {
  return request({
    requestForm: true,
    url: '/teacher/user/getAuthUrl',
    method: 'post'
  })
}

export function wxLogin(code) {
  return  request({
    requestForm: true,
    url: '/teacher/user/wxLogin',
    method: 'post',
    data: {code}
  })
}

export function logout() {
  return request({
    requestForm: true,
    url: '/teacher/user/logout',
    method: 'post'
  })
}

export async function autoLogin(key) {
  return request({
    requestForm: true,
    url: '/teacher/user/autoLogin',
    method: 'post',
    data: {key}
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js